<template>
    <DCard
        padding
    >
        <Form
            :my-antagonist-settings="myAntagonistSettings"
            :errors="errors"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/MyAntagonistSettings/Form'
import { route } from '~@/Composables/route'

defineProps({
    myAntagonistSettings: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const submitForm = function (form) {
    form.post(route('settings.my-antagonist-settings.store'))
}
</script>

<style scoped lang="scss">

</style>
